export const defaultStudySearchConfig = {

    userFilters: [
        // {
        //     "dicomStandardTagId": "00080090",
        //     "qidoQueryStringParam": "ReferringPhysicianName",
        //     "value": "MEDICO|APTIMA"
        // },
        // {
        //     "dicomStandardTagId": "00080050",
        //     "qidoQueryStringParam": "AccessionNumber",
        //     "value": "RSUNK-9999"
        // },
    ],

    searchFilters: [
        {
            dicomStandardTagId: '00100010',
            qidoQueryStringParam: 'PatientName',
            label: 'Patient Name'
        },
        {
            dicomStandardTagId: '00100020',
            qidoQueryStringParam: 'PatientID',
            label: 'Patient ID'
        },
        // {
        //     dicomStandardTagId: '00080050',
        //     qidoQueryStringParam: 'AccessionNumber',
        //     label: 'Accession Number'
        // },
        {
            dicomStandardTagId: '00080062',
            qidoQueryStringParam: 'ModalitiesInStudy',
            label: 'Modalities'
        },
        {
            dicomStandardTagId: '00081030',
            qidoQueryStringParam: 'StudyDescription',
            label: 'Study Description'
        },
        // {
        //     dicomStandardTagId: '0020000D',
        //     qidoQueryStringParam: 'StudyInstanceUID',
        //     label: 'Study Instance UID'
        // },
        // {
        //     dicomStandardTagId: '00080080',
        //     qidoQueryStringParam: 'InstitutionName',
        //     label: 'Institution Name'
        // },
        // {
        //     dicomStandardTagId: '00080090',
        //     qidoQueryStringParam: 'ReferringPhysicianName',
        //     label: 'Referring Physician Name'
        // },
    ],

    searchColumns: [
        // {
        //     dicomStandardTagId: '00080090',
        //     qidoQueryStringParam: 'ReferringPhysicianName',
        //     label: 'Referring Physician Name',
        //     width: 'large'
        // },
        {
            dicomStandardTagId: '00100010',
            qidoQueryStringParam: 'PatientName',
            label: 'Patient Name',
            width: 'medium'
        },
        {
            dicomStandardTagId: '00100020',
            qidoQueryStringParam: 'PatientID',
            label: 'Patient ID',
            width: 'medium'
        },
        // {
        //     dicomStandardTagId: '00080050',
        //     qidoQueryStringParam: 'AccessionNumber',
        //     label: 'Accession Number',
        //     width: 'medium'
        // },
        {
            dicomStandardTagId: '00080062',
            qidoQueryStringParam: 'ModalitiesInStudy',
            label: 'Modalities',
            width: 'small'
        },
        {
            dicomStandardTagId: '00081030',
            qidoQueryStringParam: 'StudyDescription',
            label: 'Study Description',
            width: 'large'
        },
        // {
        //     dicomStandardTagId: '0020000D',
        //     qidoQueryStringParam: 'StudyInstanceUID',
        //     label: 'Study Instance UID',
        //     width: 'large'
        // },
        // {
        //     dicomStandardTagId: '00080080',
        //     qidoQueryStringParam: 'InstitutionName',
        //     label: 'Institution Name',
        //     width: 'medium'
        // },
        {
            dicomStandardTagId: '00080020',
            qidoQueryStringParam: 'StudyDate',
            label: 'Study Date',
            width: 'medium'
        },
    ]

};
